import React, { ReactNode } from "react";
import { base_path } from "@/environment";
import { getAppEnv } from "@/config/app-env";

interface ImageProps {
  className?: string;
  src: string | ReactNode;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
  isBackend?: boolean; // New prop to indicate if the image is from backend
}

const ImageWithBasePath: React.FC<ImageProps> = ({
  className,
  src,
  alt,
  height,
  width,
  id,
  isBackend = false, // Default to false for backward compatibility
}) => {

  const apiBaseURL = getAppEnv().backendApi.url;

  const base_url = isBackend ? `${apiBaseURL}${src}` : `${base_path}${src}`;

  return (
    <img
      className={className}
      src={base_url}
      height={height}
      alt={alt}
      width={width}
      id={id}
    />
  );
};

export default ImageWithBasePath;
